import React       from 'react';
import classNames  from 'classnames';
import albums      from './album-import/albums';
import Select      from '../_utils/select-wrapper';
import UploadTargetRadioButton from './utils/upload-target-radio-button';
import { defaultNewAlbumTitle } from './default-new-album-title';

class AlbumSelector extends React.Component{
  constructor() {
    super();
    this.handleAlbumOptionChange        = this.handleAlbumOptionChange.bind(this);
    this.handleNewAlbumOptionFocus      = this.handleNewAlbumOptionFocus.bind(this);
    this.handleAlbumExistingOptionFocus = this.handleAlbumExistingOptionFocus.bind(this);
    this.handleSaveToAnExistingAlbum    = this.handleSaveToAnExistingAlbum.bind(this);
    this.handleSaveToANewAlbum          = this.handleSaveToANewAlbum.bind(this);

    this.state = {
      loaded: false,
      albumOption: 'new'
    };
  }
  UNSAFE_componentWillMount() {
    albums.load(() => {
      this.setState({
        loaded: true
      });
    });
  }
  componentDidMount() {
    if (!this.props.targetAlbum) {
      this.props.onAlbumSelected({
        title: defaultNewAlbumTitle()
      });
    }
  }
  render() {
    const albumList = albums.data.map(album => {
      return {
        value: album.id,
        label: album.title
      };
    });

    let heading = 'Create new album';
    if (albumList.length) {
      heading += ' or add to existing album';
    }
    const newAlbumTitle = defaultNewAlbumTitle();

    return (
      <fieldset aria-labelledby='album-select-header' className="album-selector">
        <p id="album-select-header">{ heading }</p>
          <div className="form-row form-group">
            <div className="col-5">
              <div className="form-check text-left">
                <UploadTargetRadioButton value="new"
                                         albumOption={this.state.albumOption}
                                         handleChange={this.handleAlbumOptionChange} />
                <label className="form-check-label" htmlFor="new">
                  New album:
                </label>
              </div>
            </div>
            <div className="col-7">
              <input ref="new-album-name"
                     className="form-control form-control-lg"
                     type="text"
                     placeholder={ newAlbumTitle }
                     defaultValue={ newAlbumTitle }
                     onChange={ this.handleSaveToANewAlbum }
                     onFocus= { this.handleNewAlbumOptionFocus } />
            </div>
          </div>
          <div className={ classNames('form-row form-group', { 'd-none': albumList.length == 0 }) }>
            <div className="col-5">
              <div className="form-check text-left">
                <UploadTargetRadioButton value="existing"
                                         albumOption={this.state.albumOption}
                                         handleChange={this.handleAlbumOptionChange} />
                <label htmlFor="existing" className="form-check-label">
                  Existing album:
                </label>
              </div>
            </div>
            <div className="col-7">
              <Select name="albums"
                      value={this.props.targetAlbum && this.props.targetAlbum.id || albumList[0] && albumList[0].value}
                      options={albumList}
                      onFocus={this.handleAlbumExistingOptionFocus}
                      onChange={this.handleSaveToAnExistingAlbum} />
            </div>
          </div>
      </fieldset>
    );
  }
  handleNewAlbumOptionFocus() {
    this.setState({
      albumOption: 'new'
    });
  }
  handleAlbumExistingOptionFocus() {
    this.setState({
      albumOption: 'existing'
    });
  }
  handleAlbumOptionChange(e) {
    const value = e.target.value;

    this.setState({
      albumOption: value
    });

    if (value == 'existing' && !this.props.targetAlbum.id && albums.data[0]) {
      this.handleSaveToAnExistingAlbum(albums.data[0].id)
    }
    if (value == 'new' && !this.props.targetAlbum.title) {
      this.handleSaveToANewAlbum()
    }
  }
  handleSaveToANewAlbum() {
    this.props.onAlbumSelected({
      title: this.refs['new-album-name'].value
    });
  }
  handleSaveToAnExistingAlbum(albumId) {
    if (albumId) {
      this.props.onAlbumSelected({
        id: albumId
      });
    }
  }
}

export default AlbumSelector;
